import { CheckCircle } from "@mui/icons-material";
import { fetchTasks } from "../redux/actions/taskActions";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { listAppointments, deleteAppointment } from "../redux/actions/appointmentActions";
import { APPOINTMENT_DELETE_RESET } from "../redux/constants/appointmentConstants";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { Edit as EditIcon } from "@mui/icons-material";
import { Fade } from '@mui/material'; // Add this import

import {
  Container,
  Grid,
  Card,
  CardContent,
  Box,
  Typography,
  Button,
  IconButton,
  Drawer,
  TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Menu,
  MenuItem as MuiMenuItem,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Snackbar,
  Alert,
} from "@mui/material";
import { Calendar, dateFnsLocalizer } from "react-big-calendar";
import format from "date-fns/esm/format";
import parse from "date-fns/esm/parse";
import startOfWeek from "date-fns/esm/startOfWeek";
import getDay from "date-fns/esm/getDay";
import "react-big-calendar/lib/css/react-big-calendar.css";
import EventIcon from "@mui/icons-material/Event";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import DeleteIcon from "@mui/icons-material/Delete";
import BreadcrumbNav from "../components/BreadcrumbNav";
import TasksOverview from "../components/TasksOverview";
import { largeTitle, mediumTitle } from "../styles/typography";
import { textFieldStyles } from "../styles/textFieldStyles";
import { actionButtonStyles } from "../styles/actionButton";
import { ButtonGroup } from "@mui/material";
import moment from "moment";
import { nl } from "date-fns/locale";
import enUS from "date-fns/esm/locale/en-US";

const locales = {
  "en-US": enUS,
  "nl": nl,
};
const CustomToolbar = (toolbar) => {
  const { t, i18n } = useTranslation('pages');

  const goToBack = () => {
    toolbar.onNavigate("PREV");
  };

  const goToNext = () => {
    toolbar.onNavigate("NEXT");
  };

  const goToToday = () => {
    toolbar.onNavigate("TODAY");
  };

  const goToDayView = () => {
    toolbar.onView("day");
  };

  const goToWeekView = () => {
    toolbar.onView("week");
  };

  const goToMonthView = () => {
    toolbar.onView("month");
  };

  // Format date according to current language
  const currentDate = i18n.language === 'nl' 
    ? format(toolbar.date, "dd MMMM, yyyy", { locale: nl })
    : format(toolbar.date, "dd MMMM, yyyy", { locale: enUS });

  return (
    <div
      className="rbc-toolbar"
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <ButtonGroup>
        <Button
          onClick={goToBack}
          style={{
            borderRadius: 0,
            fontSize: "10.5px",
            fontFamily: "Fira Sans, Helvetica, Arial, sans-serif",
          }}
        >
          {t('calendar.back')}
        </Button>
        <Button
          onClick={goToToday}
          style={{
            borderRadius: 0,
            fontSize: "10.5px",
            fontFamily: "Fira Sans, Helvetica, Arial, sans-serif",
          }}
        >
          {t('calendar.today')}
        </Button>
        <Button
          onClick={goToNext}
          style={{
            borderRadius: 0,
            fontSize: "10.5px",
            fontFamily: "Fira Sans, Helvetica, Arial, sans-serif",
          }}
        >
          {t('calendar.next')}
        </Button>
      </ButtonGroup>
      <span
        style={{
          margin: "0 20px",
          borderRadius: 0,
          fontSize: "14px",
          fontWeight: 600,
          fontFamily: "Fira Sans, Helvetica, Arial, sans-serif",
        }}
      >
        {currentDate}
      </span>
      <ButtonGroup>
        <Button
          onClick={goToDayView}
          style={{
            borderRadius: 0,
            fontSize: "10.5px",
            fontFamily: "Fira Sans, Helvetica, Arial, sans-serif",
          }}
        >
          {t('calendar.day')}
        </Button>
        <Button
          onClick={goToWeekView}
          style={{
            borderRadius: 0,
            fontSize: "10.5px",
            fontFamily: "Fira Sans, Helvetica, Arial, sans-serif",
          }}
        >
          {t('calendar.week')}
        </Button>
        <Button
          onClick={goToMonthView}
          style={{
            borderRadius: 0,
            fontSize: "10.5px",
            fontFamily: "Fira Sans, Helvetica, Arial, sans-serif",
          }}
        >
          {t('calendar.month')}
        </Button>
      </ButtonGroup>
    </div>
  );
};
const localizer = dateFnsLocalizer({
  format: (date, formatStr, options) =>
    format(date, formatStr, { locale: options?.locale }),
  parse: (dateStr, formatStr, options) =>
    parse(dateStr, formatStr, new Date(), { locale: options?.locale }),
  startOfWeek: (date, options) =>
    startOfWeek(date, { locale: options?.locale }),
  getDay: (date) => getDay(date),
  locales,
});

const formatDate = (date, language = 'en') => {
  const locale = language === 'nl' ? 'nl-NL' : 'en-US';
  return date.toLocaleString(locale, {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
  });
};

const formatDateTask = (dateString, language = 'en') => {
  const locale = language === 'nl' ? 'nl-NL' : 'en-US';
  const options = { day: "2-digit", month: "short", year: "numeric" };
  return new Date(dateString)
    .toLocaleDateString(locale, options)
    .replace(/,/g, "");
};
const Event = ({ event }) => {
  const { i18n } = useTranslation();
  const startDate = event.startDate || event.start;
  const eventTitle = event.title || event.subject || 'Event';
  
  return (
    <Tooltip
      title={startDate ? `${eventTitle}: ${formatDate(new Date(startDate), i18n.language)}` : eventTitle}
      arrow
    >
      <span>{eventTitle}</span>
    </Tooltip>
  );
};



const CalendarPage = () => {
  const { t, i18n } = useTranslation('pages');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { tasks } = useSelector((state) => state.taskList);

  const { appointments } = useSelector((state) => state.appointmentList);
  const {
    loading: deleteLoading,
    success: deleteSuccess,
    error: deleteError
  } = useSelector((state) => state.appointmentDelete);

  const [view, setView] = useState("month");
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [filterDate, setFilterDate] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const { user } = useSelector((state) => state.userLoaded); // Assuming user info is stored in auth state

  // State for delete confirmation dialog
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [appointmentToDelete, setAppointmentToDelete] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);

  // State for notification snackbar
  const [notification, setNotification] = useState({
    open: false,
    message: '',
    severity: 'info'
  });

  useEffect(() => {
    dispatch(listAppointments());
    if (!tasks || tasks.length === 0) {
      dispatch(fetchTasks());
    }
  }, [dispatch]);
  const handleEventClick = (event) => {
    setSelectedEvent(event);
    setDrawerOpen(true);
  };

  useEffect(() => {
    console.log(user);
  }, [user]);

  useEffect(() => {
    console.log(appointments.owner?._id);
  }, [appointments]);

  // Handle delete success or error
  useEffect(() => {
    if (deleteSuccess && !isDeleting) {
      const appointmentType = appointmentToDelete?.calendarType || 'appointment';
      setNotification({
        open: true,
        message: t('pages:calendar.deleted_successfully', { type: appointmentType }),
        severity: 'success'
      });
      dispatch(listAppointments()); // Refresh the list
    } else if (deleteError && !isDeleting) {
      setNotification({
        open: true,
        message: deleteError,
        severity: 'error'
      });
    }
  }, [deleteSuccess, deleteError, isDeleting, appointmentToDelete, dispatch, t]);

  // Handle opening delete confirmation dialog
  const handleDeleteClick = (appointment) => {
    setAppointmentToDelete(appointment);
    setDeleteDialogOpen(true);
  };

  // Handle confirming delete
  const handleConfirmDelete = async () => {
    if (appointmentToDelete) {
      setIsDeleting(true);
      await dispatch(deleteAppointment(appointmentToDelete._id));
      setTimeout(() => {
        setIsDeleting(false);
      }, 1000);
    }
    setDeleteDialogOpen(false);
    setAppointmentToDelete(null);
  };

  // Handle canceling delete
  const handleCancelDelete = () => {
    setDeleteDialogOpen(false);
    setAppointmentToDelete(null);
  };

  // Handle notification close
  const handleCloseNotification = () => {
    setNotification({
      ...notification,
      open: false
    });
    // Reset the delete state
    dispatch({ type: APPOINTMENT_DELETE_RESET });
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
    setSelectedEvent(null);
  };

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleEditEvent = () => {
    if (selectedEvent) {
      const editPage =
        selectedEvent.calendarType === "Appointment"
          ? `/appointment/${selectedEvent._id}`
          : `/hearing/${selectedEvent._id}`;
      navigate(editPage);
    }
  };

  const handleCreateAppointment = () => {
    navigate("/appointment/create");
    handleMenuClose();
  };

  const handleCreateHearing = () => {
    navigate("/hearing/create");
    handleMenuClose();
  };

  const filteredAppointments = filterDate
    ? (appointments || []).filter(
        (appointment) =>
          new Date(appointment.startDate).toDateString() ===
            new Date(filterDate).toDateString() &&
          appointment.owner?._id.toString() === user?.relationship.toString()
      )
    : (appointments || []).filter(
        (appointment) =>
          appointment?.owner._id.toString() === user?.relationship.toString()
      );

  const filteredTasks = (tasks || []).filter(
    (task) => task.owner?._id.toString() === user?.relationship.toString()
  );

  const eventStyleGetter = (event) => {
    const backgroundColor = event.colour || "#3174ad";
    const style = {
      backgroundColor,
      borderRadius: "5px",
      opacity: 0.8,
      color: "white",
      border: "0px",
      display: "block",
    };
    return {
      style,
      className: "custom-event", // Add a custom class
    };
  };
  const handleAddTaskClick = () => {
    navigate("/task/create");
  };

  const completedTasksCount = (filteredTasks || []).filter(
    (task) => task.status === "Completed"
  ).length;
  const overdueTasksCount = (filteredTasks || []).filter(
    (task) => new Date(task.dueDate) < new Date() && task.status !== "Completed"
  ).length;
  const upcomingTasksCount = (filteredTasks || []).filter(
    (task) =>
      new Date(task.dueDate) >= new Date() && task.status !== "Completed"
  ).length;

  // Add this CSS to your styles
  const styles = `
    .custom-event {
      height: 15px !important; // Set the height as needed
      font-size: 12px; // Decrease the font size
      text-transform: capitalize; // Set text to capitalize
    }
  `;

  // Inject the styles into the document
  const styleSheet = document.createElement("style");
  styleSheet.type = "text/css";
  styleSheet.innerText = styles;
  document.head.appendChild(styleSheet);

  const convertToDate = (date) => {
    return typeof date === "string" ? new Date(date) : date;
  };

  return (
    <>
      <Container
        maxWidth="lg"
        sx={{
          backgroundColor: "white",
          boxShadow: "0px 4px 16px rgba(0,0,0,0.013)", // Reduced shadow spread
          pt: 2,
          pb: 4,
          marginBottom: 8,
          marginTop: 2,
          width: "85%",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "0",
            margin: "0",
            mb: 4,
            mt: 2,
            gap: 2,
          }}
        >
          <BreadcrumbNav
            style={{
              fontFamily:
                "Fira Sans, Helvetica Neue, Helvetica, Roboto, Arial, sans-serif",
            }}
            title={t('calendar.title')}
          />
          <Button
            onClick={handleMenuClick}
            endIcon={<ArrowDropDownIcon />}
            startIcon={
              <Box display="flex" alignItems="center">
                <AddIcon />
                <Box ml={1} />
              </Box>
            }
            sx={actionButtonStyles}
          >
            {t('calendar.add_to_calendar')}
          </Button>
          <Menu
            PaperProps={{
              style: {
                width: anchorEl ? anchorEl.clientWidth : undefined,
                boxShadow: "0px 3px 12px rgba(0, 0, 0, 0.1)",
                borderRadius: "0",
                fontFamily:
                  "Fira Sans, Helvetica Neue, Helvetica, Roboto, Arial, sans-serif",
              },
            }}
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
          >
            <MuiMenuItem
              sx={{
                fontFamily:
                  "Fira Sans, Helvetica Neue, Helvetica, Roboto, Arial, sans-serif",
              }}
              onClick={handleCreateAppointment}
            >
              {t('calendar.create_appointment')}
            </MuiMenuItem>
            <MuiMenuItem
              sx={{
                fontFamily:
                  "Fira Sans, Helvetica Neue, Helvetica, Roboto, Arial, sans-serif",
              }}
              onClick={handleCreateHearing}
            >
              {t('calendar.create_hearing')}
            </MuiMenuItem>
          </Menu>
        </Box>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={2}
        >
          {/* <TextField
            label="Filter by Date"
            type="date"
            InputLabelProps={{
              shrink: true,
            }}
            value={filterDate}
            onChange={(e) => setFilterDate(e.target.value)}
            size="small"
            sx={textFieldStyles({ width: "25%", marginRight: "0" })}
          /> */}
        </Box>
        <Calendar
          localizer={localizer}
          culture={i18n.language === 'nl' ? 'nl' : 'en-US'}
          events={filteredAppointments.map((event) => ({
            ...event,
            startDate: convertToDate(event.startDate),
            endDate: convertToDate(event.endDate),
          }))}
          startAccessor="startDate"
          endAccessor="endDate"
          style={{
            height: 600,
            fontFamily:
              "Fira Sans, Helvetica Neue, Helvetica, Roboto, Arial, sans-serif",
          }}
          views={["day", "week", "month"]}
          view={view}
          onView={(view) => setView(view)}
          onSelectEvent={handleEventClick}
          eventPropGetter={eventStyleGetter}
          components={{
            toolbar: CustomToolbar,
            event: ({ event }) => (
              <span>
                {event.title}
                {view === "month" && ` - ${event.subject}`}
              </span>
            ),
          }}
        />
        {/* <Grid container className="mt-2" sx={{ marginTop: 4 }}>
        
      </Grid> */}
        <Drawer anchor="right" open={drawerOpen} onClose={handleDrawerClose}>
          <Box p={2} width={300}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography variant="h6" sx={largeTitle}>
                {t('calendar.event_details')}
              </Typography>
              <IconButton onClick={handleDrawerClose}>
                <CloseIcon />
              </IconButton>
            </Box>
            {selectedEvent && (
              <Box mt={2}>
                <Typography variant="subtitle1">
                  <strong>{t('calendar.event')}:</strong> {selectedEvent.calendarType}
                </Typography>
                <Typography variant="subtitle1">
                  <strong>{t('calendar.case')}:</strong> {selectedEvent.case?.name}
                </Typography>
                <Typography variant="subtitle1">
                  <strong>{t('calendar.type')}:</strong> {selectedEvent.type}
                </Typography>
                <Typography variant="subtitle1">
                  <strong>{t('calendar.subject')}:</strong> {selectedEvent.subject}
                </Typography>
                <Typography variant="subtitle1">
                  <strong>{t('calendar.description')}:</strong> {selectedEvent.description}
                </Typography>
                <Typography variant="subtitle1">
                  <strong>{t('calendar.start')}:</strong>{" "}
                  {formatDate(new Date(selectedEvent.startDate), i18n.language)}
                </Typography>
                <Typography variant="subtitle1">
                  <strong>{t('calendar.end')}:</strong>{" "}
                  {formatDate(new Date(selectedEvent.endDate), i18n.language)}
                </Typography>
                <Typography variant="subtitle1">
                  <strong>{t('calendar.location')}:</strong> {selectedEvent.location}
                </Typography>
                <Typography variant="subtitle1">
                  <strong>{t('calendar.reminder')}:</strong> {selectedEvent.reminder} {t('calendar.days_before')}
                </Typography>
                <Box sx={{ display: 'flex', gap: 1, mt: 2 }}>
                  <Button
                    onClick={handleEditEvent}
                    startIcon={<EditIcon />}
                    sx={{
                      ...actionButtonStyles(),
                      height: '32px', // Reduced height to match global styling
                      minHeight: '32px'
                    }}
                  >
                    {t('calendar.edit')} {selectedEvent.calendarType}
                  </Button>
                  <IconButton
                    onClick={() => handleDeleteClick(selectedEvent)}
                    color="error"
                    sx={{
                      ...actionButtonStyles(),
                      backgroundColor: 'transparent',
                      color: '#d32f2f',
                      border: '1px solid #d32f2f',
                      borderRadius: '0',
                      height: '32px', // Reduced height to match global styling
                      width: '32px',
                      minHeight: '32px',
                      minWidth: '32px',
                      padding: '4px',
                      '&:hover': {
                        backgroundColor: '#d32f2f',
                        color: 'white',
                      }
                    }}
                  >
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </Box>
              </Box>
            )}
          </Box>
        </Drawer>
      </Container>
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <Box
          sx={{
            backgroundColor: "white",
            width: "60%",
            height: "550px",
            padding: 4,
          }}
        >
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item>
              <Typography
                variant="h6"
                sx={{
                  mediumTitle,
                  fontFamily:
                    "Fira Sans, Helvetica Neue, Helvetica, Roboto, Arial, sans-serif",
                }}
              >
                {t('calendar.tasks')}
              </Typography>
            </Grid>
            <Grid item>
              <IconButton
                onClick={() => navigate("/task/create")}
                style={{ cursor: "pointer", padding: "5px" }}
              >
                <AddIcon
                  sx={{
                    fontSize: "24px",
                    color: "#2B80B6",
                  }}
                />
              </IconButton>
            </Grid>
          </Grid>
          {/* <Box sx={mediumTitle}>Tasks</Box> */}
          <TasksOverview filteredTasks={filteredTasks} />
        </Box>
      </Box>

      {/* Delete Confirmation Dialog */}
      <Dialog
        open={deleteDialogOpen}
        onClose={handleCancelDelete}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {appointmentToDelete?.calendarType === 'Appointment'
            ? t('pages:calendar.delete_appointment')
            : t('pages:calendar.delete_hearing')
          }
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {t('pages:calendar.delete_confirmation', {
              type: appointmentToDelete?.calendarType || 'appointment'
            })}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelDelete} color="primary">
            {t('buttons:cancel')}
          </Button>
          <Button
            onClick={handleConfirmDelete}
            color="error"
            variant="contained"
            startIcon={<DeleteIcon />}
            autoFocus
          >
            {t('common:delete')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Notification Snackbar */}
      <Snackbar
        open={notification.open}
        autoHideDuration={6000}
        onClose={handleCloseNotification}
      >
        <Alert
          onClose={handleCloseNotification}
          severity={notification.severity}
          sx={{ width: "100%" }}
        >
          {notification.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default CalendarPage;
